module.exports = __webpack_public_path__ + "img/kenny.4f73784f.png";